import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import hi from './locales/hi.json';
import fr from './locales/fr.json';
import es from './locales/es.json';
import de from './locales/de.json';
import ru from './locales/ru.json';
import it from './locales/it.json';

const savedLang = localStorage.getItem('khajuraho_lang') || 'en';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    hi: { translation: hi },
    fr: { translation: fr },
    es: { translation: es },
    de: { translation: de },
    ru: { translation: ru },
    it: { translation: it },
  },
  lng: savedLang,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  returnObjects: true,
  parseMissingKeyHandler: (key) => {
    const lang = i18n.language;
    if (!key || lang === 'en') return key;
    const cacheKey = `khajuraho_trans_${lang}_${key}`;
    try {
      const cached = localStorage.getItem(cacheKey);
      if (cached) return JSON.parse(cached);
    } catch {}
    fetch(`https://translate.googleapis.com/translate_a/single?client=gtx&sl=en&tl=${lang}&dt=t&q=${encodeURIComponent(key)}`)
      .then(res => res.json())
      .then(data => {
        const text = data[0].map(s => s[0]).join('');
        if (text) {
          try { localStorage.setItem(cacheKey, JSON.stringify(text)); } catch {}
          i18n.addResourceBundle(lang, 'translation', { [key]: text }, true, true);
          i18n.emit('languageChanged');
        }
      })
      .catch(() => {});
    return key;
  },
});

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
  localStorage.setItem('khajuraho_lang', lng);
});

export default i18n;
